var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3936 38.9999H9.81915C9.7345 38.9999 9.65333 38.9572 9.59348 38.8811C9.53362 38.8051 9.5 38.702 9.5 38.5945V33.7296C9.5 33.6221 9.53362 33.519 9.59348 33.443C9.65333 33.3669 9.7345 33.3242 9.81915 33.3242H15.5638C15.6485 33.3242 15.7296 33.3669 15.7895 33.443C15.8493 33.519 15.883 33.6221 15.883 33.7296C15.883 33.8371 15.8493 33.9403 15.7895 34.0163C15.7296 34.0923 15.6485 34.135 15.5638 34.135H10.1383V38.1891H19.3936C19.4782 38.1891 19.5594 38.2318 19.6193 38.3078C19.6791 38.3838 19.7127 38.487 19.7127 38.5945C19.7127 38.702 19.6791 38.8051 19.6193 38.8811C19.5594 38.9572 19.4782 38.9999 19.3936 38.9999Z",
    fill: "url(#paint0_linear_2173_8510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7763 38.9999H19.3934C19.3087 38.9999 19.2275 38.9572 19.1677 38.8811C19.1078 38.8051 19.0742 38.702 19.0742 38.5945V33.7296C19.0742 33.6221 19.1078 33.519 19.1677 33.443C19.2275 33.3669 19.3087 33.3242 19.3934 33.3242C19.478 33.3242 19.5592 33.3669 19.619 33.443C19.6789 33.519 19.7125 33.6221 19.7125 33.7296V38.1891H25.7763C25.861 38.1891 25.9421 38.2318 26.002 38.3078C26.0618 38.3838 26.0955 38.487 26.0955 38.5945C26.0955 38.702 26.0618 38.8051 26.002 38.8811C25.9421 38.9572 25.861 38.9999 25.7763 38.9999Z",
    fill: "url(#paint1_linear_2173_8510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 39H25.778C25.6933 39 25.6122 38.9573 25.5523 38.8812C25.4925 38.8052 25.4588 38.7021 25.4588 38.5946V33.7297C25.4588 33.6222 25.4925 33.5191 25.5523 33.4431C25.6122 33.367 25.6933 33.3243 25.778 33.3243C25.8626 33.3243 25.9438 33.367 26.0036 33.4431C26.0635 33.5191 26.0971 33.6222 26.0971 33.7297V38.1892H33.1184V33.7297C33.1184 33.5058 33.2612 33.3243 33.4375 33.3243C33.6138 33.3243 33.7567 33.5058 33.7567 33.7297V38.5946C33.7567 38.7021 33.7231 38.8052 33.6632 38.8812C33.6033 38.9573 33.5222 39 33.4375 39ZM23.8631 34.1351H15.5652C15.4806 34.1351 15.3994 34.0924 15.3396 34.0164C15.2797 33.9404 15.2461 33.8372 15.2461 33.7297V28.8649C15.2461 28.7574 15.2797 28.6542 15.3396 28.5782C15.3994 28.5022 15.4806 28.4595 15.5652 28.4595C15.6499 28.4595 15.7311 28.5022 15.7909 28.5782C15.8508 28.6542 15.8844 28.7574 15.8844 28.8649V33.3243H23.8631C23.9477 33.3243 24.0289 33.367 24.0888 33.4431C24.1486 33.5191 24.1822 33.6222 24.1822 33.7297C24.1822 33.8372 24.1486 33.9404 24.0888 34.0164C24.0289 34.0924 23.9477 34.1351 23.8631 34.1351Z",
    fill: "url(#paint2_linear_2173_8510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5217 34.1351H23.8621C23.7775 34.1351 23.6963 34.0924 23.6364 34.0164C23.5766 33.9404 23.543 33.8372 23.543 33.7297V28.8649C23.543 28.7574 23.5766 28.6542 23.6364 28.5782C23.6963 28.5022 23.7775 28.4595 23.8621 28.4595C23.9468 28.4595 24.0279 28.5022 24.0878 28.5782C24.1476 28.6542 24.1813 28.7574 24.1813 28.8649V33.3243H31.5217C31.698 33.3243 31.8408 33.5058 31.8408 33.7297C31.8408 33.9537 31.698 34.1351 31.5217 34.1351Z",
    fill: "url(#paint3_linear_2173_8510)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1808 34.1352H31.5212C31.4366 34.1352 31.3554 34.0925 31.2955 34.0165C31.2357 33.9405 31.2021 33.8374 31.2021 33.7298V28.865C31.2021 28.641 31.3449 28.4596 31.5212 28.4596C31.6975 28.4596 31.8404 28.641 31.8404 28.865V33.3244H38.8616V29.2704H33.4361C33.2598 29.2704 33.1169 29.0889 33.1169 28.865C33.1169 28.641 33.2598 28.4596 33.4361 28.4596H39.1808C39.2654 28.4596 39.3466 28.5023 39.4064 28.5783C39.4663 28.6543 39.4999 28.7575 39.4999 28.865V33.7298C39.4999 33.8374 39.4663 33.9405 39.4064 34.0165C39.3466 34.0925 39.2654 34.1352 39.1808 34.1352ZM19.3936 29.2704H9.81915C9.7345 29.2704 9.65333 29.2277 9.59348 29.1516C9.53362 29.0756 9.5 28.9725 9.5 28.865V24.0001C9.5 23.8926 9.53362 23.7895 9.59348 23.7135C9.65333 23.6374 9.7345 23.5947 9.81915 23.5947H15.5638C15.6485 23.5947 15.7296 23.6374 15.7895 23.7135C15.8493 23.7895 15.883 23.8926 15.883 24.0001C15.883 24.1077 15.8493 24.2108 15.7895 24.2868C15.7296 24.3628 15.6485 24.4055 15.5638 24.4055H10.1383V28.4596H19.3936C19.4782 28.4596 19.5594 28.5023 19.6193 28.5783C19.6791 28.6543 19.7127 28.7575 19.7127 28.865C19.7127 28.9725 19.6791 29.0756 19.6193 29.1516C19.5594 29.2277 19.4782 29.2704 19.3936 29.2704Z",
    fill: "url(#paint4_linear_2173_8510)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4146 29.2704H19.3934C19.3087 29.2704 19.2275 29.2277 19.1677 29.1516C19.1078 29.0756 19.0742 28.9725 19.0742 28.865V24.0001C19.0742 23.8926 19.1078 23.7895 19.1677 23.7135C19.2275 23.6374 19.3087 23.5947 19.3934 23.5947C19.478 23.5947 19.5592 23.6374 19.619 23.7135C19.6789 23.7895 19.7125 23.8926 19.7125 24.0001V28.4596H26.4146C26.4993 28.4596 26.5804 28.5023 26.6403 28.5783C26.7001 28.6543 26.7338 28.7575 26.7338 28.865C26.7338 28.9725 26.7001 29.0756 26.6403 29.1516C26.5804 29.2277 26.4993 29.2704 26.4146 29.2704Z",
    fill: "url(#paint5_linear_2173_8510)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 29.27H26.4163C26.3316 29.27 26.2505 29.2273 26.1906 29.1513C26.1307 29.0752 26.0971 28.9721 26.0971 28.8646V23.9997C26.0971 23.8922 26.1307 23.7891 26.1906 23.7131C26.2505 23.6371 26.3316 23.5943 26.4163 23.5943C26.5009 23.5943 26.5821 23.6371 26.6419 23.7131C26.7018 23.7891 26.7354 23.8922 26.7354 23.9997V28.4592H33.1184V23.9997C33.1184 23.7758 33.2612 23.5943 33.4375 23.5943C33.6138 23.5943 33.7567 23.7758 33.7567 23.9997V28.8646C33.7567 28.9721 33.7231 29.0752 33.6632 29.1513C33.6033 29.2273 33.5222 29.27 33.4375 29.27ZM25.1397 24.4052H15.5652C15.4806 24.4052 15.3994 24.3624 15.3396 24.2864C15.2797 24.2104 15.2461 24.1073 15.2461 23.9997V19.1349C15.2461 19.0274 15.2797 18.9243 15.3396 18.8482C15.3994 18.7722 15.4806 18.7295 15.5652 18.7295C15.6499 18.7295 15.7311 18.7722 15.7909 18.8482C15.8508 18.9243 15.8844 19.0274 15.8844 19.1349V23.5943H25.1397C25.2243 23.5943 25.3055 23.6371 25.3654 23.7131C25.4252 23.7891 25.4588 23.8922 25.4588 23.9997C25.4588 24.1073 25.4252 24.2104 25.3654 24.2864C25.3055 24.3624 25.2243 24.4052 25.1397 24.4052Z",
    fill: "url(#paint6_linear_2173_8510)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5224 24.4052H25.1395C25.0548 24.4052 24.9736 24.3624 24.9138 24.2864C24.8539 24.2104 24.8203 24.1073 24.8203 23.9997V19.1349C24.8203 19.0274 24.8539 18.9243 24.9138 18.8482C24.9736 18.7722 25.0548 18.7295 25.1395 18.7295C25.2241 18.7295 25.3053 18.7722 25.3651 18.8482C25.425 18.9243 25.4586 19.0274 25.4586 19.1349V23.5943H31.5224C31.6987 23.5943 31.8416 23.7758 31.8416 23.9997C31.8416 24.2237 31.6987 24.4052 31.5224 24.4052Z",
    fill: "url(#paint7_linear_2173_8510)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1808 24.4053H31.5212C31.4366 24.4053 31.3554 24.3625 31.2955 24.2865C31.2357 24.2105 31.2021 24.1074 31.2021 23.9999V19.135C31.2021 18.9111 31.3449 18.7296 31.5212 18.7296C31.6975 18.7296 31.8404 18.9111 31.8404 19.135V23.5944H38.8616V19.5404H33.4361C33.2598 19.5404 33.1169 19.3589 33.1169 19.135C33.1169 18.9111 33.2598 18.7296 33.4361 18.7296H39.1808C39.2654 18.7296 39.3466 18.7723 39.4064 18.8483C39.4663 18.9244 39.4999 19.0275 39.4999 19.135V23.9999C39.4999 24.1074 39.4663 24.2105 39.4064 24.2865C39.3466 24.3625 39.2654 24.4053 39.1808 24.4053ZM19.3936 19.5404H9.81915C9.7345 19.5404 9.65333 19.4977 9.59348 19.4217C9.53362 19.3456 9.5 19.2425 9.5 19.135V14.2702C9.5 14.1626 9.53362 14.0595 9.59348 13.9835C9.65333 13.9075 9.7345 13.8647 9.81915 13.8647H15.5638C15.6485 13.8647 15.7296 13.9075 15.7895 13.9835C15.8493 14.0595 15.883 14.1626 15.883 14.2702C15.883 14.3777 15.8493 14.4808 15.7895 14.5568C15.7296 14.6328 15.6485 14.6756 15.5638 14.6756H10.1383V18.7296H19.3936C19.4782 18.7296 19.5594 18.7723 19.6193 18.8483C19.6791 18.9244 19.7127 19.0275 19.7127 19.135C19.7127 19.2425 19.6791 19.3456 19.6193 19.4217C19.5594 19.4977 19.4782 19.5404 19.3936 19.5404Z",
    fill: "url(#paint8_linear_2173_8510)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0529 19.5404H19.3934C19.3087 19.5404 19.2275 19.4977 19.1677 19.4217C19.1078 19.3456 19.0742 19.2425 19.0742 19.135V14.2702C19.0742 14.1626 19.1078 14.0595 19.1677 13.9835C19.2275 13.9075 19.3087 13.8647 19.3934 13.8647C19.478 13.8647 19.5592 13.9075 19.619 13.9835C19.6789 14.0595 19.7125 14.1626 19.7125 14.2702V18.7296H27.0529C27.2292 18.7296 27.3721 18.9111 27.3721 19.135C27.3721 19.3589 27.2292 19.5404 27.0529 19.5404Z",
    fill: "url(#paint9_linear_2173_8510)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 19.5405H27.0546C26.9699 19.5405 26.8887 19.4978 26.8289 19.4218C26.769 19.3457 26.7354 19.2426 26.7354 19.1351V14.2703C26.7354 14.0463 26.8783 13.8649 27.0546 13.8649C27.2309 13.8649 27.3737 14.0463 27.3737 14.2703V18.7297H33.1184V14.2703C33.1184 14.0463 33.2612 13.8649 33.4375 13.8649C33.6138 13.8649 33.7567 14.0463 33.7567 14.2703V19.1351C33.7567 19.2426 33.7231 19.3457 33.6632 19.4218C33.6033 19.4978 33.5222 19.5405 33.4375 19.5405ZM25.1397 14.6757H15.5652C15.4806 14.6757 15.3994 14.6329 15.3396 14.5569C15.2797 14.4809 15.2461 14.3778 15.2461 14.2703V9.4054C15.2461 9.29788 15.2797 9.19477 15.3396 9.11874C15.3994 9.04271 15.4806 9 15.5652 9H25.1397C25.1816 9 25.2231 9.01049 25.2618 9.03086C25.3005 9.05123 25.3357 9.08109 25.3654 9.11874C25.395 9.15639 25.4185 9.20108 25.4345 9.25026C25.4506 9.29945 25.4588 9.35217 25.4588 9.4054C25.4588 9.45864 25.4506 9.51136 25.4345 9.56055C25.4185 9.60973 25.395 9.65442 25.3654 9.69207C25.3357 9.72971 25.3005 9.75958 25.2618 9.77995C25.2231 9.80032 25.1816 9.81081 25.1397 9.81081H15.8844V13.8649H25.1397C25.2243 13.8649 25.3055 13.9076 25.3654 13.9836C25.4252 14.0596 25.4588 14.1627 25.4588 14.2703C25.4588 14.3778 25.4252 14.4809 25.3654 14.5569C25.3055 14.6329 25.2243 14.6757 25.1397 14.6757Z",
    fill: "url(#paint10_linear_2173_8510)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5224 14.6757H25.1395C25.0548 14.6757 24.9736 14.6329 24.9138 14.5569C24.8539 14.4809 24.8203 14.3778 24.8203 14.2703V9.4054C24.8203 9.29788 24.8539 9.19477 24.9138 9.11874C24.9736 9.04271 25.0548 9 25.1395 9H31.5224C31.6987 9 31.8416 9.18146 31.8416 9.4054C31.8416 9.62935 31.6987 9.81081 31.5224 9.81081H25.4586V13.8649H31.5224C31.6987 13.8649 31.8416 14.0463 31.8416 14.2703C31.8416 14.4942 31.6987 14.6757 31.5224 14.6757Z",
    fill: "url(#paint11_linear_2173_8510)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1818 14.6757H31.5223C31.4376 14.6757 31.3565 14.6329 31.2966 14.5569C31.2368 14.4809 31.2031 14.3778 31.2031 14.2703V9.4054C31.2031 9.29788 31.2368 9.19477 31.2966 9.11874C31.3565 9.04271 31.4376 9 31.5223 9H39.1818C39.2665 9 39.3476 9.04271 39.4075 9.11874C39.4673 9.19477 39.501 9.29788 39.501 9.4054V14.2703C39.501 14.3778 39.4673 14.4809 39.4075 14.5569C39.3476 14.6329 39.2665 14.6757 39.1818 14.6757ZM31.8414 13.8649H38.8627V9.81081H31.8414V13.8649Z",
    fill: "url(#paint12_linear_2173_8510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8510",
    x1: 9.5,
    y1: 36.162,
    x2: 19.7127,
    y2: 36.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2173_8510",
    x1: 19.0742,
    y1: 36.162,
    x2: 26.0955,
    y2: 36.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2173_8510",
    x1: 15.2461,
    y1: 33.7297,
    x2: 33.7567,
    y2: 33.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2173_8510",
    x1: 23.543,
    y1: 31.2973,
    x2: 31.8408,
    y2: 31.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2173_8510",
    x1: 9.5,
    y1: 28.865,
    x2: 39.4999,
    y2: 28.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2173_8510",
    x1: 19.0742,
    y1: 26.4326,
    x2: 26.7338,
    y2: 26.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2173_8510",
    x1: 15.2461,
    y1: 23.9997,
    x2: 33.7567,
    y2: 23.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2173_8510",
    x1: 24.8203,
    y1: 21.5673,
    x2: 31.8416,
    y2: 21.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2173_8510",
    x1: 9.5,
    y1: 19.135,
    x2: 39.4999,
    y2: 19.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2173_8510",
    x1: 19.0742,
    y1: 16.7026,
    x2: 27.3721,
    y2: 16.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2173_8510",
    x1: 15.2461,
    y1: 14.2703,
    x2: 33.7567,
    y2: 14.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2173_8510",
    x1: 24.8203,
    y1: 11.8378,
    x2: 31.8416,
    y2: 11.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2173_8510",
    x1: 31.2031,
    y1: 11.8378,
    x2: 39.501,
    y2: 11.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardscape);
export default __webpack_public_path__ + "static/media/Hardscape.a32efdc8e88c8f8f715aa0ad6bd1a029.svg";
export { ForwardRef as ReactComponent };